import { module } from 'angular';

import { CANCEL_MODAL_SERVICE } from './cancelModal.service';

export const CANCEL_MODAL_MODULE = 'spinnaker.core.cancelModal';
module(CANCEL_MODAL_MODULE, [
  CANCEL_MODAL_SERVICE,
]);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/cancelModal/cancelModal.module.ts